import * as z from 'zod';

const timeZoneZod = z.object({
  name: z.string(),
  value: z.enum(['', 'Alaska Time', 'Mountain Time', 'Eastern Time', 'Central Time', 'Pacific Time', 'Hawaii Time']),
});

type TTimeZone = z.infer<typeof timeZoneZod>;

export const defaultTimeZoneOption: TTimeZone = { name: 'None', value: '' };

export const timeZoneOptions: TTimeZone[] = [
  { ...defaultTimeZoneOption },
  { name: 'Alaska Time', value: 'Alaska Time' },
  { name: 'Mountain Time', value: 'Mountain Time' },
  { name: 'Eastern Time', value: 'Eastern Time' },
  { name: 'Central Time', value: 'Central Time' },
  { name: 'Pacific Time', value: 'Pacific Time' },
  { name: 'Hawaii Time', value: 'Hawaii Time' },
];

export function timeZoneSchema(optional = true) {
  return timeZoneZod.refine(({ value }) => optional || value !== '', {
    message: "Time Zone can't be None",
  });
}

export function strToTimeZone(str: string): TTimeZone {
  return timeZoneOptions.find((item) => item.value === str) ?? defaultTimeZoneOption;
}
